import React from 'react';

const LocalCtas: React.FC = () => {
  const setUrlPath = (urlPath: string) => {
    window.history.pushState(null, '', `${urlPath}`);
  };
  // Tier 1 VLP
  // US
  const vlpUsTier1 = (
    <button
      id="digital-leads"
      type="button"
      data-testid="vlp-button-us"
      data-info='{"vehicleId": "WAUJ8BFW3S7901665", "vehicleType": "new", "dealerId": "25A70", "presetForm":"contact-dealer"}'
      // onClick={() => setUrlPath('/inventory/?tier1')}
    >
      US VLP Tier 1
    </button>
  );
  // CA
  const vlpCaTier1 = (
    <button
      id="digital-leads"
      type="button"
      data-testid="vlp-button-ca"
      data-info='{"vehicleId": "WA1GUAFZ7TP002896", "vehicleType": "new", "dealerId": "93247", "presetForm":"contact-dealer"}'
      // onClick={() => setUrlPath('/inventory/?tier1')}
    >
      CA VLP Tier 1
    </button>
  );
  // Tier 3 VLP
  // US
  const vlpUsTier3 = null;
  // CA
  const vlpCaTier3 = null;
  // Tier 3 VDP
  // US
  const vdpUsTier3 = null;
  // CA
  const vdpCaTier3 = null;

  // Offers
  // US
  const offersLeaseUs = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-lease-button-us"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"90210","modelName":"2025 Audi Q3 S line 45 TFSI quattro","modelYear":2025,"trimName":"Premium","image":"https://nar.media.audi.com/is/image/audinar/nemo/us/offers/standard-images/q3_2025_F3BCEA_Premium.png","offerType":"lease","offerDetails":{"customerDownPayment":3999,"term":36,"monthlyPayment":"$429","creditBonus":2500,"creditBonusDisclaimer":"Excludes tax, title, license, options, and dealer fees. $0 security deposit. For highly qualified customers. Offer valid only in CA. Optional features increase price.","aprRate":0,"modelFamily":"Q3","cpoTerm":null,"type":"new"}}}'
      // onClick={() => setUrlPath('/inventory/?tier1')}
    >
      Offers US - lease
    </button>
  );

  const offersFinanceUs = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-finance-button-us"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"90210","modelName":"2025 Audi Q5 quattro","modelYear":2025,"trimName":"Premium Plus","image":"https://nar.media.audi.com/is/image/audinar/country/us/en/offers/assets/2025/all-new-q5-premium-plus/2025_GUBAAY_Premium_Plus_Standard_Image.png","offerType":"finance","offerDetails":{"customerDownPayment":0,"term":72,"monthlyPayment":"$15","creditBonus":0,"creditBonusDisclaimer":"For highly qualified customers.","aprRate":0.02989,"modelFamily":"Q5","cpoTerm":null,"type":"new"}}}'
      // onClick={() => setUrlPath('/inventory/?tier1')}
    >
      Offers US - finance
    </button>
  );

  const offersCreditUs = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-credit-button-us"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"90210","modelName":"2026 Audi Q7 55 TFSI quattro","modelYear":2026,"trimName":"Premium Plus","image":"https://nar.media.audi.com/is/image/audinar/country/us/en/offers/assets/2026/q7/55-premium-plus/2026_4MQAX2_Premium_Plus_StandardImage.png","offerType":"credit","offerDetails":{"customerDownPayment":0,"term":0,"monthlyPayment":null,"creditBonus":6000,"creditBonusDisclaimer":"When you purchase or lease a select, new 2026 Audi Q7 55 TFSI quattro.*","aprRate":0,"modelFamily":"Q7","cpoTerm":null,"type":"new"}}}'
      // onClick={() => setUrlPath('/inventory/?tier1')}
    >
      Offers US - bonus
    </button>
  );

  // CA
  const offersLeaseCa = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-lease-button-ca"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"","modelName":"2025 Audi Q3","modelYear":2025,"trimName":"40 TFSI quattro Komfort","image":"https://mediaservice.audi.com/media/fast/v3_x2TX2hbdRTHf_1kq11yk5t7u2ZJGhvtzY3tQ1ySZkmrjaxFZMIG1doqzFJuk1_SdPm35Kbr1Ad98A-KQ9Q53MMG_hmIc6AORLSCf3EUYYii7kHskzLqg3-ggg686Xn4cM7h-z2ch3Mu_i52d1qCo9MX_9r3T2_fA78gxFpTCNenwtWsl3uEEEX2VGpWWe536n3G8bGEXLMT1mpzfzqZPpCYmhtLZxP3jCUTVrWauG9sdm5eFTc5NrG7az7toOegg95tB7seETvsNh_v4ted-phLiD5H3Ct2wtffaVWbVsuq3d6S7Waj3q6sSm1kYik5nsvKwoGJnFXKJIvZ0niukCpmJmQyW5DZQjqTk7KUHdedEV8IV8GqC3_BKkqrKlvJVKHaaMui6C2NLS11LLGruzy3LnBzicAsgfcJ3UZoktB7hP2EnyN8gYgg8irRN4l-RHSD6FWGv2f4T4wejLsxyhh_E99LfJL4EuIg7k9Q1vC-jW8a9RbUHME1gu8weIXICpEFYlcx_yA-iogj0ogq2jraBtp_6BoDLxPIEi4R6SeSIOYidg3zIcx3cXtQcih34cug2egW-gsE3IRWCG0Q2ia8RUwlZhA7T-xDzBSeaZTL6PcSeJ3AV3g_w_sBvtfQUmiTaAtoFtpltM_RvkMfQc-iz6DPoXcYeJ7QOpH7GbrG0DZD_xL1EzWIjjJ8HeMVDBvjY4wviR0mdgOzHzOEuYl4CeVBlDfwnsH7M2oN9Sz-OfwXCJ8gcg5jAvVOgm0UDfVH9E32nmXgKAPLBJ4lsE5wlOAKwaeIlhjexCxhHsd8EfMKwoN4jD3Xcbdwn8e9gUfieRTP1yhvoVzC-zTeU3h_wncI38P4bHynUKdQn0Bdwx8jdIZBncglIt8ytE70DqLzRFcZvoExgnaI0EnCTxLxYXyD8RvmMygulEG8C_hO49tC3ULrQztH4CSBH7r3LeurlVajXpN1O3-kcWRq8VCj05aL01bhWLNq2bIdP1Ep2sv51EQ6GV-WlfKynU9lMsm4VW0uW3m71ZHxglWTLSs_a3eKlcbi1GJ6MZl0BHXn7eyKc_75mUa70s0Od-3xti1lq1IvW_VyVeadsTVpW0XLtlZlq-2o8ul-19T8zP-8p0ZZ3AMAAA","offerType":"lease","offerDetails":{"customerDownPayment":4381.042437425827,"term":48,"monthlyPayment":"$488","creditBonus":0,"creditBonusDisclaimer":"short description here","aprRate":"0.02480","modelFamily":"Q3","cpoTerm":null,"type":"NEW-CAR"}}}'
    >
      Offers CA - lease
    </button>
  );

  const offersFinanceCa = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-finance-button-ca"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"","modelName":"2025 Audi Q3","modelYear":2025,"trimName":"40 TFSI quattro Komfort","image":"https://mediaservice.audi.com/media/fast/v3_x2TX2hbdRTHf_1kq11yk5t7u2ZJGhvtzY3tQ1ySZkmrjaxFZMIG1doqzFJuk1_SdPm35Kbr1Ad98A-KQ9Q53MMG_hmIc6AORLSCf3EUYYii7kHskzLqg3-ggg686Xn4cM7h-z2ch3Mu_i52d1qCo9MX_9r3T2_fA78gxFpTCNenwtWsl3uEEEX2VGpWWe536n3G8bGEXLMT1mpzfzqZPpCYmhtLZxP3jCUTVrWauG9sdm5eFTc5NrG7az7toOegg95tB7seETvsNh_v4ted-phLiD5H3Ct2wtffaVWbVsuq3d6S7Waj3q6sSm1kYik5nsvKwoGJnFXKJIvZ0niukCpmJmQyW5DZQjqTk7KUHdedEV8IV8GqC3_BKkqrKlvJVKHaaMui6C2NLS11LLGruzy3LnBzicAsgfcJ3UZoktB7hP2EnyN8gYgg8irRN4l-RHSD6FWGv2f4T4wejLsxyhh_E99LfJL4EuIg7k9Q1vC-jW8a9RbUHME1gu8weIXICpEFYlcx_yA-iogj0ogq2jraBtp_6BoDLxPIEi4R6SeSIOYidg3zIcx3cXtQcih34cug2egW-gsE3IRWCG0Q2ia8RUwlZhA7T-xDzBSeaZTL6PcSeJ3AV3g_w_sBvtfQUmiTaAtoFtpltM_RvkMfQc-iz6DPoXcYeJ7QOpH7GbrG0DZD_xL1EzWIjjJ8HeMVDBvjY4wviR0mdgOzHzOEuYl4CeVBlDfwnsH7M2oN9Sz-OfwXCJ8gcg5jAvVOgm0UDfVH9E32nmXgKAPLBJ4lsE5wlOAKwaeIlhjexCxhHsd8EfMKwoN4jD3Xcbdwn8e9gUfieRTP1yhvoVzC-zTeU3h_wncI38P4bHynUKdQn0Bdwx8jdIZBncglIt8ytE70DqLzRFcZvoExgnaI0EnCTxLxYXyD8RvmMygulEG8C_hO49tC3ULrQztH4CSBH7r3LeurlVajXpN1O3-kcWRq8VCj05aL01bhWLNq2bIdP1Ep2sv51EQ6GV-WlfKynU9lMsm4VW0uW3m71ZHxglWTLSs_a3eKlcbi1GJ6MZl0BHXn7eyKc_75mUa70s0Od-3xti1lq1IvW_VyVeadsTVpW0XLtlZlq-2o8ul-19T8zP-8p0ZZ3AMAAA","offerType":"finance","offerDetails":{"customerDownPayment":4381.042437425827,"term":60,"monthlyPayment":"$737","creditBonus":0,"creditBonusDisclaimer":"short description here","aprRate":"0.02480","modelFamily":"Q3","cpoTerm":null,"type":"NEW-CAR"}}}'
    >
      Offers CA - finance
    </button>
  );

  const offersFinanceUsedCa = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-finance-used-button-ca"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"","modelName":"2019 Audi Q3","modelYear":2019,"trimName":"base","image":"https://mediaservice.audi.com/media/fast/v3_1vzloG1tIiBKdppzWfxH2wcIQ-YGBgqChgYmFIZmAvy0hkZGBhSmDgzcxPTU_WBfHHpQmPd1IoS3bzU3Hx9IwNDS9004yTdQGPdxJwcfkZuJFl2oFYRHgbBUsO7jO_9GD8wNl-L_OtetPiH6kkGHgafdR3rmhWmT7ZyNtvt84RDmpEhlgEoXJtS7Zcwye-9m9XO79rWlT23_n5QAwpvDHczyP6x68xJ_9zFEhfVXD-9nxcLFN5bofibJc5C4OaTE5c7_56UTb9uIQgUPlSfe-SV-rp6s9kSlW9DvAs0-rjOAIU39XWcihZ_flc5MmCDXO9j05tX2VuAwiwLJzb_zLskFun_ZdqhpCuhwfMmrQYKJ2-5ECl0dXV_wLrPzUvmz6j4Nm3jWqDwrq6mY9xnW2JXskWKrOdO-yIkyjUVKPxHXOJN-3Sdq58b9S-YM__506XKswoovN7Eq6RYq8Rpy6YAAQ6Nv6v5GSUMgcLHNvFalQiGiIoJ5u3UtFgR8XDBcZAhU6wN9nd-68_U_fB7w96Kmk13GSu3A4XD9ixOurTd4tsb-4jwJd-qdjvPPRyN2_Pbvy49nq_0ItEm6WP-nMUnog6nH2EECj-cXH5z3ufsV06rfjx5WnbN7HBO1CWg8AlXFeVfqcGzfy7kXyp49tR3JdE9-UDh2fPDP-iaeDx6__X9lSaps_0T452WMDAzMHAA45SNAQz4hEuLcgoSixJz9YpSiwvy84ozy1IFNQyIBMKsPo6RrkEAthqnwoACAAA","offerType":"finance","offerDetails":{"customerDownPayment":0,"term":0,"monthlyPayment":null,"creditBonus":0,"creditBonusDisclaimer":"null","aprRate":0.0449,"modelFamily":"Q3","cpoTerm":"apr0_36","type":"USED-CAR"}}}'
    >
      Offers CPO CA - finance
    </button>
  );

  // No bonus offers at this moment
  const offersCreditCa = (
    <button
      id="digital-leads"
      type="button"
      data-testid="offers-credit-button-ca"
      data-info='{"presetForm":"contact-dealer","dealerId":null,"offers":{"zip":"","modelName":"2025 Audi Q3","modelYear":2025,"trimName":"40 TFSI quattro Komfort","image":"https://mediaservice.audi.com/media/fast/v3_x2TX2hbdRTHf_1kq11yk5t7u2ZJGhvtzY3tQ1ySZkmrjaxFZMIG1doqzFJuk1_SdPm35Kbr1Ad98A-KQ9Q53MMG_hmIc6AORLSCf3EUYYii7kHskzLqg3-ggg686Xn4cM7h-z2ch3Mu_i52d1qCo9MX_9r3T2_fA78gxFpTCNenwtWsl3uEEEX2VGpWWe536n3G8bGEXLMT1mpzfzqZPpCYmhtLZxP3jCUTVrWauG9sdm5eFTc5NrG7az7toOegg95tB7seETvsNh_v4ted-phLiD5H3Ct2wtffaVWbVsuq3d6S7Waj3q6sSm1kYik5nsvKwoGJnFXKJIvZ0niukCpmJmQyW5DZQjqTk7KUHdedEV8IV8GqC3_BKkqrKlvJVKHaaMui6C2NLS11LLGruzy3LnBzicAsgfcJ3UZoktB7hP2EnyN8gYgg8irRN4l-RHSD6FWGv2f4T4wejLsxyhh_E99LfJL4EuIg7k9Q1vC-jW8a9RbUHME1gu8weIXICpEFYlcx_yA-iogj0ogq2jraBtp_6BoDLxPIEi4R6SeSIOYidg3zIcx3cXtQcih34cug2egW-gsE3IRWCG0Q2ia8RUwlZhA7T-xDzBSeaZTL6PcSeJ3AV3g_w_sBvtfQUmiTaAtoFtpltM_RvkMfQc-iz6DPoXcYeJ7QOpH7GbrG0DZD_xL1EzWIjjJ8HeMVDBvjY4wviR0mdgOzHzOEuYl4CeVBlDfwnsH7M2oN9Sz-OfwXCJ8gcg5jAvVOgm0UDfVH9E32nmXgKAPLBJ4lsE5wlOAKwaeIlhjexCxhHsd8EfMKwoN4jD3Xcbdwn8e9gUfieRTP1yhvoVzC-zTeU3h_wncI38P4bHynUKdQn0Bdwx8jdIZBncglIt8ytE70DqLzRFcZvoExgnaI0EnCTxLxYXyD8RvmMygulEG8C_hO49tC3ULrQztH4CSBH7r3LeurlVajXpN1O3-kcWRq8VCj05aL01bhWLNq2bIdP1Ep2sv51EQ6GV-WlfKynU9lMsm4VW0uW3m71ZHxglWTLSs_a3eKlcbi1GJ6MZl0BHXn7eyKc_75mUa70s0Od-3xti1lq1IvW_VyVeadsTVpW0XLtlZlq-2o8ul-19T8zP-8p0ZZ3AMAAA","offerType":"finance","offerDetails":{"customerDownPayment":4381.042437425827,"term":60,"monthlyPayment":"$737","creditBonus":0,"creditBonusDisclaimer":"short description here","aprRate":"0.02480","modelFamily":"Q3","cpoTerm":null,"type":"NEW-CAR"}}}'
    >
      Offers CA - bonus
    </button>
  );

  // MLP
  // US
  const mlpUs = (
    <a
      id="digital-leads"
      data-testid="mlp-button-us"
      href="#contact&form=general&carline=q5-2025-GU"
      onClick={() => setUrlPath('/models/?tier1')}
    >
      MLP US
    </a>
  );
  // CA
  const mlpCa = null;
  // NGC
  // US
  const ngcUs = (
    <a
      id="digital-leads"
      data-testid="ngc-button-us"
      href="#contact&form=general&audiCode=AZE9DAJW"
      onClick={() => setUrlPath('/build/?tier1')}
    >
      NGC US
    </a>
  );
  // CA
  const ngcCa = null;

  const exclusive = (
    <a
      id="digital-leads"
      data-testid="ngc-button-us"
      href="#contact&form=basic&requestType=ContactDealer-exclusive"
    >
      Exclusive form
    </a>
  );

  return (
    <div>
      {vlpUsTier1}
      {vlpCaTier1}
      {mlpUs}
      {ngcUs}
      {exclusive}
      {offersLeaseUs}
      {offersFinanceUs}
      {offersCreditUs}
      {offersLeaseCa}
      {offersFinanceCa}
      {offersFinanceUsedCa}
    </div>
  );
};

export default LocalCtas;
